// extracted by mini-css-extract-plugin
export default {"sbEllipsisNext":"src-components-Ellipsis-SbEllipsis__sbEllipsisNext--YOCHA","sbEllipsisMultilineNext":"src-components-Ellipsis-SbEllipsis__sbEllipsisMultilineNext--rjpNj"};